import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CrmIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Crm",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.5 15c-1.93 0-3.5-1.57-3.5-3.5S14.57 8 16.5 8 20 9.57 20 11.5 18.43 15 16.5 15m0-5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5M18 29H7c-1.65 0-3-1.35-3-3V9c0-.55.45-1 1-1s1 .45 1 1v17c0 .55.45 1 1 1h11c.55 0 1 .45 1 1s-.45 1-1 1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 25H11c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1h11c.55 0 1-.45 1-1v-9c0-.55.45-1 1-1s1 .45 1 1v9c0 1.65-1.35 3-3 3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.66 21c-.36 0-.71-.2-.89-.54-.45-.86-1.32-1.39-2.27-1.39s-1.82.53-2.27 1.39c-.25.49-.86.68-1.35.42a.994.994 0 0 1-.42-1.35c.79-1.52 2.34-2.47 4.04-2.47s3.25.95 4.04 2.47c.26.49.07 1.09-.42 1.35-.15.08-.31.11-.46.11Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.66 21c-.36 0-.71-.2-.89-.54-.45-.86-1.32-1.39-2.27-1.39s-1.82.53-2.27 1.39c-.25.49-.86.68-1.35.42a.994.994 0 0 1-.42-1.35c.79-1.52 2.34-2.47 4.04-2.47s3.25.95 4.04 2.47c.26.49.07 1.09-.42 1.35-.15.08-.31.11-.46.11ZM24.5 9a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0 5"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.5 10C22.57 10 21 8.43 21 6.5S22.57 3 24.5 3 28 4.57 28 6.5 26.43 10 24.5 10m0-5c-.83 0-1.5.67-1.5 1.5S23.67 8 24.5 8 26 7.33 26 6.5 25.33 5 24.5 5"
    })]
  }));
};